export const DOCUMENT_FORM = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}
